/*
 * @,@Author: ,: chenxupeng.cxp@bytedance.com
 * @,@LastEditors: ,: chenxupeng.cxp@bytedance.com
 */
// 按需全局引入 vant组件
import Vue from 'vue';
import { Button, List, Cell, Tabbar, TabbarItem, Popup, Divider, Notify, Form, Field, NavBar, Toast, Icon, Dialog, Checkbox, CheckboxGroup } from 'vant';
Vue.use(Button);
Vue.use(Cell);
Vue.use(List);
Vue.use(Popup);
Vue.use(Divider);
Vue.use(Notify);
Vue.use(Form);
Vue.use(Field);
Vue.use(NavBar);
Vue.use(Toast);
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Tabbar).use(TabbarItem);
